import React, {useState, useEffect} from 'react';
import {t, getLanguage} from 'react-switch-lang';
import {
  getAllProcesses,
  getAllSubProcesses,
  getAllDepartments,
  sendStatement,
} from '../../services/reports/kriReport';
import FormatList from './reportForm/components/format/FormatList';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {useUserContext} from '../../contexts/UserContext';
import SelectList from '../../components/FormFields/Select';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import {format} from 'date-fns';
import Toast from '../../components/toast/Toast';
import Swal from 'sweetalert2';
import './Report.scss';
import {getAllPotentialRiskTypes} from '../../services/potentialRiskTypesService';

const OccurredRiskReport = (props) => {
  const isValidType = '';

  const lang = getLanguage();
  const [selectedFormat, setSelectedFormat] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [isSubmittedStatement, setIsSubmittedStatement] = useState(false);

  const [processes, setProcesses] = useState([]);
  const [subProcesses, setSubProcesses] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [potentialRiskTypes, setPotentialRiskTypes] = useState([]);
  const [format2, setFormat2] = useState('');

  const fetchProcesses = async () => {
    try {
      const {data} = await getAllProcesses();
      setProcesses(data);
      return data;
    } catch (e) {}
  };

  const fetchDepartments = async () => {
    try {
      const {data} = await getAllDepartments();
      setDepartments(data);
      return data;
    } catch (e) {}
  };
  const fetchPotentialRiskType = async () => {
    try {
      const {data} = await getAllPotentialRiskTypes();
      setPotentialRiskTypes(data);
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchProcesses().then((r) => {
      let processes = [];
      r.forEach((item) => {
        processes.push(
          lang === 'eng'
            ? {value: item.id, label: item.nameEn}
            : {
                value: item.id,
                label: item.name,
              }
        );
      });

      setProcesses(processes);
    });

    fetchDepartments().then((r) => {
      let departments = [];
      r.forEach((item) => {
        departments.push(
          lang === 'eng'
            ? {value: item.id, label: item.nameEn}
            : {
                value: item.id,
                label: item.name,
              }
        );
      });

      setDepartments(departments);
    });

    fetchPotentialRiskType().then((r) => {
      let potentialRiskTypes = [];
      r.forEach((item) => {
        potentialRiskTypes.push(
          lang === 'eng'
            ? {value: item.id, label: item.nameEn}
            : {
              value: item.id,
              label: item.name,
            }
        );
      });

      setPotentialRiskTypes(potentialRiskTypes);
    });
  }, []);

  const schema = yup.object().shape({
    process: yup.object().nullable().required(t('message.fieldRequired')),
    subprocess: yup.object().nullable().required(t('message.fieldRequired')),
    department: yup.object().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, errors, setValue} = methods;
  const processSelected = watch('process');
  let validFrom = watch('startDate');
  let validTo = watch('endDate');
  let departmentWatch = watch('department');
  const riskStatusValue = watch('riskState');

  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(processSelected['value']);
      setSubProcesses(data);
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    if (processSelected) {
      fetchSubprocesses().then((r) => {
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }

    if (processSelected === null) {
      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [processSelected]);

  const user = useUserContext();

  let userRiskSector = false;
  let responsibleUser = false;
  let userInCharge = false;

  user.authorities.forEach((item) => {
    if (item === 'ROLE_RISK_SECTOR') {
      userRiskSector = true;
    }
    if (item === 'ROLE_RESPONSIBLE_USER') {
      responsibleUser = true;
    }
    if (item === 'ROLE_USER_IN_CHARGE') {
      userInCharge = true;
    }
  });

  useEffect(() => {
    setSelectedFormat();
    setIsSubmitted(false);
    setIsSubmittedStatement(false);
  }, []);

  const sendStatementClick = async () => {
    setIsSubmittedStatement(true);

    if (departmentWatch && validTo && validFrom) {
      let departmentId = departmentWatch?.value;
      let dateEnd = encodeURIComponent(format(validTo, 'yyyy-MM-dd'));
      let dateStart = encodeURIComponent(format(validFrom, 'yyyy-MM-dd'));

      try {
        const response = await sendStatement(dateStart, dateEnd, departmentId);
        if (response.status === 200) {
          await Toast.fire({
            title: t('message.sendSuccess'),
            icon: 'success',
          });
          setIsSubmittedStatement(false);
        }
      } catch (err) {
        if (err.response.data.code === 'month-report-not-empty') {
          Swal.fire({
            text: `${
              t('message.month-report-not-empty') +
              ' ' +
              t('message.has') +
              ' ' +
              err.response.data.detail +
              ' ' +
              t('message.risks')
            }  `,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
        if (err.response.data.code === 'month-report-user-not-in-department') {
          Swal.fire({
            text: `${t('message.month-report-user-not-in-department')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
        setIsSubmittedStatement(false);
      }
    }
  };

  const riskStatusList = [
    {value: 'OPEN', label: getLanguage() === 'mne' ? 'Otvoren' : 'Open'},
    {value: 'CLOSED', label: getLanguage() === 'mne' ? 'Zatvoren' : 'Closed'},
  ];

  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5">
              <label className="label" htmlFor="startDate">
                {t('reports.dateFrom')}
              </label>
              <InputDate
                name="startDate"
                maxDate={validTo}
                //defaultValue={new Date()}
                defaultValue={
                  new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                }
                className={`date-height form-control ${
                  validFrom === null && isSubmitted === true
                    ? `error-field`
                    : validFrom === null && isSubmittedStatement === true
                    ? `error-field`
                    : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateFrom')}
              />
              {validFrom === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : validFrom === null && isSubmittedStatement === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <div className="form-group pr-5">
              <label className="label" htmlFor="endDate">
                {t('reports.dateTo')}
              </label>
              <InputDate
                name="endDate"
                minDate={validFrom}
                defaultValue={new Date()}
                className={`date-height form-control ${
                  validTo === null && isSubmitted === true
                    ? `error-field`
                    : validTo === null && isSubmittedStatement === true
                    ? `error-field`
                    : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateTo')}
              />
              {validTo === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : validTo === null && isSubmittedStatement === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <div className=" form-group pr-5">
              <label className="label w-100" htmlFor="process">
                {t('reports.processes')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="process"
                options={processes}
                defaultValue=""
                placeholder={t('common.select')}
              />
            </div>

            <div className="form-group pr-5">
              <label className="label w-100" htmlFor="subprocess">
                {t('reports.subprocesses')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="subprocess"
                defaultValue=""
                isDisabled={!processSelected}
                placeholder={t('common.select')}
                options={subProcesses}
              />
            </div>

            <div className="form-group pr-5">
              <label className="label w-100" htmlFor="department">
                {t('reports.department')}
              </label>
              <SelectList
                name="department"
                className={`select ${
                  !departmentWatch && isSubmittedStatement === true
                    ? `error-field`
                    : ''
                }`}
                options={departments}
                placeholder={t('common.select')}
              />
              {!departmentWatch && isSubmittedStatement === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <div className=" form-group pr-5">
              <label className="label w-100" htmlFor="potentialRiskType">
                {t('reports.potentialRiskType')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="potentialRiskType"
                options={potentialRiskTypes}
                defaultValue=""
                placeholder={t('common.select')}
              />
            </div>
            <div className=" form-group pr-5">
              <label className="label w-100" htmlFor="riskEstimation">
                {t('potentialRisk.riskEstimation')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="riskEstimation"
                options={
                  getLanguage() === 'eng'
                    ? [{label: 'Low'}, {label: 'Medium'}, {label: 'High'}]
                    : [{label: 'Nizak'}, {label: 'Umjeren'}, {label: 'Visok'}]
                }
                placeholder={t('common.select')}
                defaultValue=""
              />
            </div>
            <div className="form-group pr-5">
              <label className="label w-100" htmlFor="riskType">
                {t('reports.status')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="riskState"
                options={riskStatusList}
                placeholder={t('common.select')}
              />
            </div>
            <FormatList
              isValidType={isValidType}
              value={['PDF', 'XLSX']}
              parameterName="format"
              onChange={(e) => setFormat2(e)}
              isSubmitted={isSubmitted}
              setIsSubmitted={() => setIsSubmitted(false)}
              setSelectedFormat={(e) => setSelectedFormat(e.toLowerCase())}
              error={!format2.length > 0}
            />
            <DownloadBtn
              api={'reports/risks/risk-with-measures-report'}
              paramsLength={9}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              apiParameters={{
                startDate:
                  validFrom !== null && validFrom !== undefined
                    ? `startDate=${encodeURIComponent(
                        format(validFrom, 'yyyy-MM-dd')
                      )}`
                    : '',
                endDate:
                  validTo !== null && validTo !== undefined
                    ? `endDate=${encodeURIComponent(
                        format(validTo, 'yyyy-MM-dd')
                      )}`
                    : '',
                processId:
                  watch('process') !== null &&
                  watch('process') !== undefined &&
                  watch('process').value !== undefined
                    ? `processId=${watch('process').value}`
                    : `processId=`,
                subprocessId:
                  watch('subprocess') !== null &&
                  watch('subprocess') !== undefined &&
                  watch('subprocess').value !== undefined
                    ? `subprocessId=${watch('subprocess').value}`
                    : `subprocessId=`,
                departmentId:
                  watch('department') !== null &&
                  watch('department') !== undefined &&
                  watch('department').value !== undefined
                    ? `departmentId=${watch('department').value}`
                    : `departmentId=`,
                potentialRiskTypeId:
                  watch('potentialRiskType') !== null &&
                  watch('potentialRiskType') !== undefined &&
                  watch('potentialRiskType').value !== undefined
                    ? `potentialRiskTypeId=${watch('potentialRiskType').value}`
                    : `potentialRiskTypeId=`,
                riskEstimation:
                  watch('riskEstimation') !== null &&
                  watch('riskEstimation') !== undefined &&
                  watch('riskEstimation').label !== undefined
                    ? `riskEstimation=${watch('riskEstimation').label}`
                    : `riskEstimation=`,
                format: format2,
                riskState:
                  riskStatusValue !== null && riskStatusValue !== undefined
                    ? `riskState=${watch('riskState').value}`
                    : 'riskState=',
              }}
            />
            {responsibleUser || userInCharge ? (
              <div className="ml-2">
                <button
                  className="report-button blue"
                  type="submit"
                  onClick={sendStatementClick}
                >
                  {t('buttons.send')}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default OccurredRiskReport;
